

<template>
  <br>
  <center>
    <div class="d-flex w-100  p-4">
      <div class="col-4">
        <div v-for="index in allOne" class="card_tree ccc  d-flex my-5">
          <div class="col-4">{{index.title}}</div>
          <div class="col-10">
            <button @click.prevent="allItemsParent(index.id)" class="button">اجزا</button></div>
        </div>
      </div>
      <div class="col-4 mx-2">
        <div v-for="index in allTwo" class="card_two ccc d-flex my-5">
          <div class="col-4">{{index.title}}</div>
          <div class="col-10">
            <button @click.prevent="allItemsParent(index.id)" class="button">اجزا</button></div>
        </div>
      </div>
      <div class="col-4">
        <div v-for="index in allTree" class="card_one ccc  d-flex my-5">
          <div class="col-4">{{index.title}}</div>
          <div class="col-10">
            <button @click.prevent="allItemsParent(index.id)" class="button">اجزا</button></div>
        </div>
      </div>

    </div>
  </center>
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="more"
       style="z-index: 999999999999999999999999999999999999999999999; top: 28%; width: 70vw;">
    <div>
      <p> لیست </p>
      <p @click="more=!more">❌</p>
    </div>
    <div>
      <center  v-show="!allParents.length">
        موردی یافت نشد
      </center>

      <table v-show="allParents.length" class="table table-striped" style="width: 65vw;" >
        <thead>
        <tr>
          <th>کد  </th>
          <th>عنوان  </th>
          <th>ماهیت حساب  </th>
          <th>  جایگاه  </th>
          <th>  مرکز هزینه  </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in allParents"  :style="item.parent_id ?  'background-color:#7981FC !important;': 'background-color:#5E67FC;'">
          <td>{{item.code}}</td>
          <td>{{item.title}}</td>
          <td>{{item.nature}}</td>
          <td>{{item.position}}</td>
          <td>{{item.organizationpost.name}}</td>

        </tr>

        </tbody>
      </table>

      <button @click="more=!more">بازگشت</button>
    </div>
  </div>



</template>
<script  >
export default {
  data(){
   return{
     allOne: [],
     allTwo: [],
     allTree: [],
     allParents: [],
     more: false,
     id_route: this.$route['params']['id'],

   }
  },
  methods:{
    allItems(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/profit_and_loss_structure/chart_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
              this.allOne.length=0
              this.allTwo.length=0
              this.allTree.length=0
              response.items1.forEach((ele)=>{
                this.allOne.push(ele)
              })
              response.items2.forEach((ele)=>{
                this.allTwo.push(ele)
              })
              response.items3.forEach((ele)=>{
                this.allTree.push(ele)
              })


          })
          .catch();
    },
    allItemsParent(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/profit_and_loss_structure/chart/items/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
           this.allParents.length=0
            response.items.forEach((ele)=>{
              this.allParents.push(ele)
            })
            this.more=true

          })
          .catch();
    },
  },
  mounted() {
    this.allItems()
  }
}
</script>
<style scoped lang="scss">
label{
  font-size: .8vw;
}
.card_one{
  background-color: #A7A6A6;
  border-radius: 1vw;
  padding: 1vw;
  &:nth-child(1){
  }
  &:nth-child(2){
    transform: translateY(4vw);

  }
  &:nth-child(3){
    transform: translateY(10vw);

  } &:nth-child(4){
        transform: translateY(11vw);

  }
  &:nth-child(5){
    transform: translateY(10vw);

  }
}
.card_two{
  background-color: #C1C1C1;
  border-radius: 1vw;
  padding: 1vw;
  &:nth-child(1){
  }
  &:nth-child(2){
  }
  &:nth-child(3){
    transform: translateY(-2vw);

    }
  &:nth-child(4){

  }
  &:nth-child(5){
  }
}.card_tree{
  background-color: #E0E0E0;
  border-radius: 1vw;
   padding: 1vw;
   &:nth-child(1){
   }
   &:nth-child(2){
     transform: translateY(6vw);

   }
   &:nth-child(3){
     transform: translateY(11.5vw);

   }
 }
 .button{
   border: 1px solid #707070;
   color: #AEB2FC;
   font-size: 1vw;
   border-radius: 1vw;
   width: 4vw;
   background-color: #fff;
 }
 .ccc{
   margin-bottom: .5vw;
   &>div:first-child{
     font-size: 1vw;
   }
 }
</style>